import { useDispatch, useSelector } from 'react-redux';
import React, { useCallback } from 'react';
import { push } from 'connected-react-router';
import clsx from 'clsx';
import { Button } from '../../../../components';
import useStyles from '../styles';
import { ProductCodes } from '../../../../types/products';
import { selectCurrentUser } from '../../../../store/modules/users/selectors';

type PurchaseProps = {
  disabled?: boolean;
  productCode: ProductCodes;
  variant?: 'contained' | 'outlined';
};

const PurchaseNowButton = ({
  productCode,
  disabled = false,
  variant = 'contained',
}: PurchaseProps) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { data: user } = useSelector(selectCurrentUser);
  const activeProductCode = user?.ref?.active_subscription?.product?.product_code as ProductCodes;
  const isActiveSub = productCode === activeProductCode;
  const defaultTitle = user ? 'Upgrade' : 'Purchase Now';
  const currentTitle = isActiveSub ? 'Your current plan' : defaultTitle;
  const onClickHandler = useCallback((e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault();
    if (!disabled && !isActiveSub) {
      const url = user ? '/dashboard/plans/checkout' : '/pages/register';
      dispatch(push(url, { productCode }));
    }
  }, [user, dispatch, productCode, disabled, isActiveSub]);

  return (
    <Button
      onClick={onClickHandler}
      disabled={disabled || isActiveSub}
      variant={variant}
      classes={{
        root: clsx(classes.button, {
          [classes.buttonPurchaseContained]: variant === 'contained',
          [classes.buttonPurchaseOutlined]: variant === 'outlined',
        }),
        label: classes.buttonLabel,
      }}
    >
      { currentTitle }
    </Button>
  );
};

export default PurchaseNowButton;
